import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6","key":"svg-0"}],["path",{"d":"M7 9l11 0","key":"svg-1"}]]

/**
 * IconCurrencyRupee
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktcnVwZWUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDVoLTExaDNhNCA0IDAgMCAxIDAgOGgtM2w2IDYiIC8+CiAgPHBhdGggZD0iTTcgOWwxMSAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-rupee
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyRupee = createReactComponent('outline', 'currency-rupee', 'CurrencyRupee', __iconNode);

export default IconCurrencyRupee;